// // v1 no cash validation
// import React from "react";
// import {
//   Box,
//   TextField,
//   Button,
//   Typography,
//   MenuItem,
//   Container,
//   Paper,
//   Stack,
//   FormControl,
//   InputLabel,
//   Select,
// } from "@mui/material";
// import { Formik, Form, FieldArray, useFormikContext } from "formik";
// import * as Yup from "yup";
// import TwoFieldRow from "./twoFieldsRow";
// import UploadWithLabel from "./uploadWithLable";
// import { useTranslation } from "react-i18next";

// const investmentValidationSchema = Yup.object({
//   investments: Yup.array()
//     .of(
//       Yup.object({
//         inv_account_no: Yup.string().required("Investment Account No is required"),
//         inv_ifsc_code: Yup.string().required("IFSC Code is required"),
//         inv_bank_name: Yup.string().required("Bank Name is required"),
//         inv_branch_name: Yup.string().required("Branch Name is required"),
//         inv_scheme: Yup.string()
//           .required("Scheme is required")
//           .test("customScheme", "Specify scheme is required", (value) =>
//             typeof value === "string" && value.trim().length > 0
//           ),
//         inv_amt: Yup.number()
//           .typeError("Amount must be a number")
//           .required("Amount is required"),
//         inv_proof: Yup.mixed()
//           .required("Bond/Statement is required")
//           .test(
//             "fileExists",
//             "Proof is required",
//             (value) => value && typeof value.name === "string" && value.name.length > 0
//           )
//           .test(
//             "fileSize",
//             "File size must be less than 2MB",
//             (value) => !value || value.size <= 2 * 1024 * 1024
//           ),
//       })
//     )
//     .min(1, "At least one investment is required"),
// });

// const TotalWatcher = ({ onTotalAmountChange }) => {
//   const { values } = useFormikContext();

//   React.useEffect(() => {
//     if (values.investments) {
//       const total = values.investments.reduce(
//         (sum, inv) => sum + (Number(inv.inv_amt) || 0),
//         0
//       );
//       onTotalAmountChange && onTotalAmountChange(total);
//     }
//   }, [values.investments, onTotalAmountChange]);

//   return null;
// };

// const InvestmentsSection = ({
//   investments,
//   setInvestments,
//   activeTab,
//   setActiveTab,
//   onTotalAmountChange,
// }) => {
//   const { t } = useTranslation();

//   const selectFormControlSX = {
//     minWidth: 200,
//     maxWidth: "100%",
//   };

//   const [showOtherScheme, setShowOtherScheme] = React.useState(
//     investments.map(() => false)
//   );

//   const formikContext = useFormikContext();

//   React.useEffect(() => {
//     if (formikContext?.values?.investments) {
//       setShowOtherScheme(
//         formikContext.values.investments.map(() => false)
//       );
//     }
//   }, [formikContext?.values?.investments]);

//   return (
//     <Formik
//       initialValues={{ investments }}
//       validationSchema={investmentValidationSchema}
//       enableReinitialize
//       onSubmit={(values) => {
//         setInvestments(values.investments);
//         setActiveTab(activeTab + 1);
//       }}
//     >
//       {({
//         values,
//         errors,
//         touched,
//         handleChange,
//         handleBlur,
//         setFieldValue,
//         setFieldTouched,
//       }) => {
//         const handleSchemeChange = (i, e) => {
//           const val = e.target.value;
//           if (val === "Other") {
//             setShowOtherScheme((prev) => {
//               const newState = [...prev];
//               newState[i] = true;
//               return newState;
//             });
//             setFieldValue(`investments[${i}].inv_scheme`, "");
//             setFieldTouched(`investments[${i}].inv_scheme`, false);
//           } else {
//             setFieldValue(`investments[${i}].inv_scheme`, val);
//             setShowOtherScheme((prev) => {
//               const newState = [...prev];
//               newState[i] = false;
//               return newState;
//             });
//           }
//         };

//         const totalInvestment = values.investments.reduce(
//           (sum, inv) => sum + (Number(inv.inv_amt) || 0),
//           0
//         );

//         return (
//           <Container maxWidth={false} sx={{ mt: 5, maxWidth: 800 }}>
//             <Paper elevation={4} sx={{ p: 4, borderRadius: 3 }}>
//               <Typography variant="h4" fontWeight="700" color="primary.main" gutterBottom>
//                 {t('investments.heading')}
//               </Typography>
//               <Form noValidate>
//                 <Stack spacing={3}>
//                   <TotalWatcher onTotalAmountChange={onTotalAmountChange} />
//                   <FieldArray name="investments">
//                     {({ remove, push }) => (
//                       <>
//                         {values.investments.map((inv, i) => (
//                           <Box
//                             key={i}
//                             mb={2}
//                             p={2}
//                             sx={{ border: "1px solid #ccc", borderRadius: 2 }}
//                           >
//                             <TwoFieldRow>
//                               <TextField
//                                 label={`${t('investments.invAccountNo')} *`}
//                                 name={`investments[${i}].inv_account_no`}
//                                 value={inv.inv_account_no}
//                                 onChange={handleChange}
//                                 onBlur={handleBlur}
//                                 error={
//                                   touched.investments?.[i]?.inv_account_no &&
//                                   Boolean(errors.investments?.[i]?.inv_account_no)
//                                 }
//                                 helperText={
//                                   touched.investments?.[i]?.inv_account_no &&
//                                   errors.investments?.[i]?.inv_account_no
//                                 }
//                                 fullWidth
//                               />
//                               <TextField
//                                 label={`${t('investments.ifscCode')} *`}
//                                 name={`investments[${i}].inv_ifsc_code`}
//                                 value={inv.inv_ifsc_code}
//                                 onChange={handleChange}
//                                 onBlur={handleBlur}
//                                 error={
//                                   touched.investments?.[i]?.inv_ifsc_code &&
//                                   Boolean(errors.investments?.[i]?.inv_ifsc_code)
//                                 }
//                                 helperText={
//                                   touched.investments?.[i]?.inv_ifsc_code &&
//                                   errors.investments?.[i]?.inv_ifsc_code
//                                 }
//                                 fullWidth
//                               />
//                             </TwoFieldRow>

//                             <TwoFieldRow>
//                               <TextField
//                                 label={`${t('investments.bankName')} *`}
//                                 name={`investments[${i}].inv_bank_name`}
//                                 value={inv.inv_bank_name}
//                                 onChange={handleChange}
//                                 onBlur={handleBlur}
//                                 error={
//                                   touched.investments?.[i]?.inv_bank_name &&
//                                   Boolean(errors.investments?.[i]?.inv_bank_name)
//                                 }
//                                 helperText={
//                                   touched.investments?.[i]?.inv_bank_name &&
//                                   errors.investments?.[i]?.inv_bank_name
//                                 }
//                                 fullWidth
//                               />
//                               <TextField
//                                 label={`${t('investments.branchName')} *`}
//                                 name={`investments[${i}].inv_branch_name`}
//                                 value={inv.inv_branch_name}
//                                 onChange={handleChange}
//                                 onBlur={handleBlur}
//                                 error={
//                                   touched.investments?.[i]?.inv_branch_name &&
//                                   Boolean(errors.investments?.[i]?.inv_branch_name)
//                                 }
//                                 helperText={
//                                   touched.investments?.[i]?.inv_branch_name &&
//                                   errors.investments?.[i]?.inv_branch_name
//                                 }
//                                 fullWidth
//                               />
//                             </TwoFieldRow>

//                             <TwoFieldRow>
//                               <Box sx={{ minWidth: 200, flex: 1 }}>
//                                 {!showOtherScheme[i] ? (
//                                   <FormControl
//                                     fullWidth
//                                     margin="normal"
//                                     error={
//                                       touched.investments?.[i]?.inv_scheme &&
//                                       Boolean(errors.investments?.[i]?.inv_scheme)
//                                     }
//                                     sx={selectFormControlSX}
//                                   >
//                                     <InputLabel id={`inv_scheme_label_${i}`}>
//                                       {t('investments.scheme')}
//                                     </InputLabel>
//                                     <Select
//                                       labelId={`inv_scheme_label_${i}`}
//                                       name={`investments[${i}].inv_scheme`}
//                                       value={inv.inv_scheme || ""}
//                                       label={t('investments.scheme')}
//                                       onChange={(e) => handleSchemeChange(i, e)}
//                                       onBlur={handleBlur}
//                                     >
//                                       <MenuItem value="">
//                                         <em>{t('common.select')}</em>
//                                       </MenuItem>
//                                       <MenuItem value="SB">{t('investments.sb')}</MenuItem>
//                                       <MenuItem value="FD">{t('investments.fd')}</MenuItem>
//                                       <MenuItem value="RD">{t('investments.rd')}</MenuItem>
//                                       <MenuItem value="PPF">{t('investments.ppf')}</MenuItem>
//                                       <MenuItem value="Other">{t('investments.other')}</MenuItem>
//                                     </Select>
//                                     {touched.investments?.[i]?.inv_scheme &&
//                                       errors.investments?.[i]?.inv_scheme && (
//                                         <Typography color="error" variant="caption" sx={{ ml: 2 }}>
//                                           {errors.investments[i].inv_scheme}
//                                         </Typography>
//                                       )}
//                                   </FormControl>
//                                 ) : (
//                                   <TextField
//                                     label={`${t('investments.specifyScheme')} *`}
//                                     name={`investments[${i}].inv_scheme`}
//                                     value={inv.inv_scheme || ""}
//                                     onChange={handleChange}
//                                     onBlur={handleBlur}
//                                     fullWidth
//                                     error={
//                                       touched.investments?.[i]?.inv_scheme &&
//                                       Boolean(errors.investments?.[i]?.inv_scheme)
//                                     }
//                                     helperText={
//                                       touched.investments?.[i]?.inv_scheme &&
//                                       errors.investments?.[i]?.inv_scheme
//                                     }
//                                     InputProps={{
//                                       endAdornment: (
//                                         <Button
//                                           onClick={() =>
//                                             setShowOtherScheme((prev) => {
//                                               const newState = [...prev];
//                                               newState[i] = false;
//                                               return newState;
//                                             })
//                                           }
//                                           size="small"
//                                           sx={{ ml: 1 }}
//                                         >
//                                           {t('common.change')}
//                                         </Button>
//                                       ),
//                                     }}
//                                   />
//                                 )}
//                               </Box>
//                               <TextField
//                                 label={`${t('investments.amount')} *`}
//                                 name={`investments[${i}].inv_amt`}
//                                 value={inv.inv_amt}
//                                 onChange={handleChange}
//                                 onBlur={handleBlur}
//                                 error={
//                                   touched.investments?.[i]?.inv_amt &&
//                                   Boolean(errors.investments?.[i]?.inv_amt)
//                                 }
//                                 helperText={
//                                   touched.investments?.[i]?.inv_amt &&
//                                   errors.investments?.[i]?.inv_amt
//                                 }
//                                 fullWidth
//                               />
//                             </TwoFieldRow>

//                             <TwoFieldRow>
//                               <Box sx={{ flex: 1 }}>
//                                 <UploadWithLabel
//                                   label={t('investments.uploadProof')}
//                                   name={`investments[${i}].inv_proof`}
//                                   onChange={(e) => {
//                                     setFieldValue(`investments[${i}].inv_proof`, e.currentTarget.files[0]);
//                                     setFieldTouched(`investments[${i}].inv_proof`, true);
//                                   }}
//                                   file={inv.inv_proof}
//                                   error={
//                                     touched.investments?.[i]?.inv_proof &&
//                                     Boolean(errors.investments?.[i]?.inv_proof)
//                                   }
//                                   helperText={
//                                     touched.investments?.[i]?.inv_proof &&
//                                     errors.investments?.[i]?.inv_proof
//                                   }
//                                 />
//                               </Box>
//                             </TwoFieldRow>

//                             <Button
//                               variant="outlined"
//                               color="error"
//                               onClick={() => remove(i)}
//                               sx={{ mt: 1 }}
//                             >
//                               {t('common.remove')}
//                             </Button>
//                           </Box>
//                         ))}

//                         <Button
//                           variant="contained"
//                           sx={{ mt: 2 }}
//                           onClick={() =>
//                             push({
//                               inv_account_no: "",
//                               inv_ifsc_code: "",
//                               inv_bank_name: "",
//                               inv_branch_name: "",
//                               inv_scheme: "",  // now default = none
//                               inv_amt: "",
//                               inv_proof: null,
//                             })
//                           }
//                         >
//                           {t('investments.addInvestment')}
//                         </Button>

//                         <Box
//                           sx={{
//                             mt: 4,
//                             p: 2,
//                             border: "1px solid #999",
//                             borderRadius: 2,
//                             backgroundColor: "#f9f9f9",
//                           }}
//                         >
//                           <Typography variant="h6" gutterBottom>
//                             {t('investments.summary')}
//                           </Typography>
//                           <TextField
//                             label={t('investments.totalInvestmentAmount')}
//                             value={totalInvestment.toFixed(2)}
//                             InputProps={{ readOnly: true }}
//                             fullWidth
//                           />
//                         </Box>
//                       </>
//                     )}
//                   </FieldArray>

//                   <Box mt={1} sx={{ display: "flex", justifyContent: "space-between" }}>
//                     <Button
//                       variant="outlined"
//                       onClick={() => activeTab > 0 && setActiveTab(activeTab - 1)}
//                     >
//                       {t('common.back')}
//                     </Button>
//                     <Button type="submit" variant="contained">
//                       {t('common.next')}
//                     </Button>
//                   </Box>
//                 </Stack>
//               </Form>
//             </Paper>
//           </Container>
//         );
//       }}
//     </Formik>
//   );
// };

// export default InvestmentsSection;


// v2 with cash validation
// import React from "react";
// import {
//   Box,
//   TextField,
//   Button,
//   Typography,
//   MenuItem,
//   Container,
//   Paper,
//   Stack,
//   FormControl,
//   InputLabel,
//   Select,
// } from "@mui/material";
// import { Formik, Form, FieldArray, useFormikContext } from "formik";
// import * as Yup from "yup";
// import TwoFieldRow from "./twoFieldsRow";
// import UploadWithLabel from "./uploadWithLable";
// import { useTranslation } from "react-i18next";

// const investmentValidationSchema = Yup.object({
//   investments: Yup.array()
//     .of(
//       Yup.object({
//         investmentMode: Yup.string().required("Investment Mode is required"),
//         inv_account_no: Yup.string()
//           .matches(/^\d+$/, "Account number must contain only digits")
//           .min(6, "Account number must be at least 6 digits")
//           .max(18, "Account number must not exceed 18 digits")
//           .when("investmentMode", {
//             is: (value) => !["Cash"].includes(value),
//             then: (schema) => schema.required("Investment Account No is required"),
//             otherwise: (schema) => schema.notRequired(),
//           }),
//         inv_ifsc_code: Yup.string()
//           .matches(
//             /^[A-Z]{4}0[A-Z0-9]{6}$/,
//             "IFSC must be 11 characters (4 letters, 0, 6 alphanumeric)"
//           )
//           .when("investmentMode", {
//             is: (value) => !["Cash"].includes(value),
//             then: (schema) => schema.required("IFSC Code is required"),
//             otherwise: (schema) => schema.notRequired(),
//           }),
//         inv_bank_name: Yup.string()
//           .matches(/^[a-zA-Z\s]+$/, "Bank name must contain only letters and spaces")
//           .min(2, "Bank name must be at least 2 characters")
//           .when("investmentMode", {
//             is: (value) => !["Cash"].includes(value),
//             then: (schema) => schema.required("Bank Name is required"),
//             otherwise: (schema) => schema.notRequired(),
//           }),
//         inv_branch_name: Yup.string()
//           .matches(/^[a-zA-Z\s]+$/, "Branch name must contain only letters and spaces")
//           .min(2, "Branch name must be at least 2 characters")
//           .when("investmentMode", {
//             is: (value) => !["Cash"].includes(value),
//             then: (schema) => schema.required("Branch Name is required"),
//             otherwise: (schema) => schema.notRequired(),
//           }),
//         inv_scheme: Yup.string()
//           .required("Scheme is required")
//           .test("customScheme", "Specify scheme is required", (value) =>
//             typeof value === "string" && value.trim().length > 0
//           ),
//         inv_amt: Yup.number()
//           .typeError("Amount must be a number")
//           .positive("Amount must be positive")
//           .required("Amount is required"),
//         inv_proof: Yup.mixed()
//           .required("Bond/Statement is required")
//           .test(
//             "fileType",
//             "Only PDF files are allowed",
//             (value) => !value || value.name.toLowerCase().endsWith('.pdf')
//           )
//           .test(
//             "fileExists",
//             "Proof is required",
//             (value) => value && typeof value.name === "string" && value.name.length > 0
//           )
//           .test(
//             "fileSize",
//             "File size must be less than 2MB",
//             (value) => !value || value.size <= 2 * 1024 * 1024
//           ),
//       })
//     )
//     .min(1, "At least one investment is required"),
// });

// const TotalWatcher = ({ onTotalAmountChange }) => {
//   const { values } = useFormikContext();

//   React.useEffect(() => {
//     if (values.investments) {
//       const total = values.investments.reduce(
//         (sum, inv) => sum + (Number(inv.inv_amt) || 0),
//         0
//       );
//       onTotalAmountChange && onTotalAmountChange(total);
//     }
//   }, [values.investments, onTotalAmountChange]);

//   return null;
// };

// const InvestmentsSection = ({
//   investments,
//   setInvestments,
//   activeTab,
//   setActiveTab,
//   onTotalAmountChange,
// }) => {
//   const { t } = useTranslation();

//   const selectFormControlSX = {
//     minWidth: 200,
//     maxWidth: "100%",
//   };

//   const initialValues = {
//     investments: investments?.length > 0 
//       ? investments.map(inv => ({
//           ...inv,
//           investmentMode: inv.investmentMode || "NEFT",
//         }))
//       : [{
//           investmentMode: "NEFT",
//           inv_account_no: "",
//           inv_ifsc_code: "",
//           inv_bank_name: "",
//           inv_branch_name: "",
//           inv_scheme: "",
//           inv_amt: "",
//           inv_proof: null,
//         }]
//   };

//   const [showOtherScheme, setShowOtherScheme] = React.useState(
//     initialValues.investments.map(() => false)
//   );

//   React.useEffect(() => {
//     if (initialValues.investments) {
//       setShowOtherScheme(initialValues.investments.map(() => false));
//     }
//   }, [initialValues.investments]);

//   return (
//     <Formik
//       initialValues={initialValues}
//       validationSchema={investmentValidationSchema}
//       enableReinitialize
//       onSubmit={(values) => {
//         setInvestments(values.investments);
//         setActiveTab(activeTab + 1);
//       }}
//     >
//       {({
//         values,
//         errors,
//         touched,
//         handleChange,
//         handleBlur,
//         setFieldValue,
//         setFieldTouched,
//         isValid,
//       }) => {
//         const handleSchemeChange = (i, e) => {
//           const val = e.target.value;
//           if (val === "Other") {
//             setShowOtherScheme((prev) => {
//               const newState = [...prev];
//               newState[i] = true;
//               return newState;
//             });
//             setFieldValue(`investments[${i}].inv_scheme`, "");
//             setFieldTouched(`investments[${i}].inv_scheme`, false);
//           } else {
//             setFieldValue(`investments[${i}].inv_scheme`, val);
//             setShowOtherScheme((prev) => {
//               const newState = [...prev];
//               newState[i] = false;
//               return newState;
//             });
//           }
//         };

//         const totalInvestment = values.investments.reduce(
//           (sum, inv) => sum + (Number(inv.inv_amt) || 0),
//           0
//         );

//         return (
//           <Container maxWidth={false} sx={{ mt: 5, maxWidth: 800 }}>
//             <Paper elevation={4} sx={{ p: 4, borderRadius: 3 }}>
//               <Typography variant="h4" fontWeight="700" color="primary.main" gutterBottom>
//                 {t('investments.heading')}
//               </Typography>
//               <Form noValidate>
//                 <Stack spacing={3}>
//                   <TotalWatcher onTotalAmountChange={onTotalAmountChange} />
                  
//                   <FieldArray name="investments">
//                     {({ remove, push }) => (
//                       <>
//                         {values.investments.map((inv, i) => {
//                           const isCashMode = inv.investmentMode === "Cash";
                          
//                           return (
//                             <Box
//                               key={i}
//                               mb={2}
//                               p={2}
//                               sx={{ border: "1px solid #ccc", borderRadius: 2 }}
//                             >
//                               {/* Investment Mode for each investment */}
//                               <FormControl 
//                                 fullWidth 
//                                 error={touched.investments?.[i]?.investmentMode && Boolean(errors.investments?.[i]?.investmentMode)}
//                                 sx={{ mb: 2 }}
//                               >
//                                 <InputLabel id={`investment_mode_label_${i}`}>
//                                   {t('investments.investmentMode') || 'Investment Mode'}
//                                 </InputLabel>
//                                 <Select
//                                   labelId={`investment_mode_label_${i}`}
//                                   name={`investments[${i}].investmentMode`}
//                                   value={inv.investmentMode || "NEFT"}
//                                   label={t('investments.investmentMode') || 'Investment Mode'}
//                                   onChange={handleChange}
//                                   onBlur={handleBlur}
//                                 >
//                                   <MenuItem value="Cash">{t('investments.cash') || 'Cash'}</MenuItem>
//                                   <MenuItem value="NEFT">{t('investments.neft') || 'NEFT'}</MenuItem>
//                                   <MenuItem value="Cheque">{t('investments.cheque') || 'Cheque'}</MenuItem>
//                                   <MenuItem value="RTGS">{t('investments.rtgs') || 'RTGS'}</MenuItem>
//                                   <MenuItem value="IMPS">{t('investments.imps') || 'IMPS'}</MenuItem>
//                                   <MenuItem value="Other">{t('investments.other') || 'Other'}</MenuItem>
//                                 </Select>
//                                 {touched.investments?.[i]?.investmentMode && errors.investments?.[i]?.investmentMode && (
//                                   <Typography color="error" variant="caption">
//                                     {errors.investments[i].investmentMode}
//                                   </Typography>
//                                 )}
//                               </FormControl>

//                               {/* Bank Details - Hidden for Cash */}
//                               {!isCashMode && (
//                                 <>
//                                   <TwoFieldRow>
//                                     <TextField
//                                       label={`${t('investments.invAccountNo')} *`}
//                                       name={`investments[${i}].inv_account_no`}
//                                       value={inv.inv_account_no}
//                                       onChange={handleChange}
//                                       onBlur={handleBlur}
//                                       error={
//                                         touched.investments?.[i]?.inv_account_no &&
//                                         Boolean(errors.investments?.[i]?.inv_account_no)
//                                       }
//                                       helperText={
//                                         touched.investments?.[i]?.inv_account_no &&
//                                         errors.investments?.[i]?.inv_account_no
//                                       }
//                                       fullWidth
//                                     />
//                                     <TextField
//                                       label={`${t('investments.ifscCode')} *`}
//                                       name={`investments[${i}].inv_ifsc_code`}
//                                       value={inv.inv_ifsc_code}
//                                       onChange={handleChange}
//                                       onBlur={handleBlur}
//                                       error={
//                                         touched.investments?.[i]?.inv_ifsc_code &&
//                                         Boolean(errors.investments?.[i]?.inv_ifsc_code)
//                                       }
//                                       helperText={
//                                         touched.investments?.[i]?.inv_ifsc_code &&
//                                         errors.investments?.[i]?.inv_ifsc_code
//                                       }
//                                       fullWidth
//                                     />
//                                   </TwoFieldRow>

//                                   <TwoFieldRow>
//                                     <TextField
//                                       label={`${t('investments.bankName')} *`}
//                                       name={`investments[${i}].inv_bank_name`}
//                                       value={inv.inv_bank_name}
//                                       onChange={handleChange}
//                                       onBlur={handleBlur}
//                                       error={
//                                         touched.investments?.[i]?.inv_bank_name &&
//                                         Boolean(errors.investments?.[i]?.inv_bank_name)
//                                       }
//                                       helperText={
//                                         touched.investments?.[i]?.inv_bank_name &&
//                                         errors.investments?.[i]?.inv_bank_name
//                                       }
//                                       fullWidth
//                                     />
//                                     <TextField
//                                       label={`${t('investments.branchName')} *`}
//                                       name={`investments[${i}].inv_branch_name`}
//                                       value={inv.inv_branch_name}
//                                       onChange={handleChange}
//                                       onBlur={handleBlur}
//                                       error={
//                                         touched.investments?.[i]?.inv_branch_name &&
//                                         Boolean(errors.investments?.[i]?.inv_branch_name)
//                                       }
//                                       helperText={
//                                         touched.investments?.[i]?.inv_branch_name &&
//                                         errors.investments?.[i]?.inv_branch_name
//                                       }
//                                       fullWidth
//                                     />
//                                   </TwoFieldRow>
//                                 </>
//                               )}

//                               <TwoFieldRow>
//                                 <Box sx={{ minWidth: 200, flex: 1 }}>
//                                   {!showOtherScheme[i] ? (
//                                     <FormControl
//                                       fullWidth
//                                       margin="normal"
//                                       error={
//                                         touched.investments?.[i]?.inv_scheme &&
//                                         Boolean(errors.investments?.[i]?.inv_scheme)
//                                       }
//                                       sx={selectFormControlSX}
//                                     >
//                                       <InputLabel id={`inv_scheme_label_${i}`}>
//                                         {t('investments.scheme')}
//                                       </InputLabel>
//                                       <Select
//                                         labelId={`inv_scheme_label_${i}`}
//                                         name={`investments[${i}].inv_scheme`}
//                                         value={inv.inv_scheme || ""}
//                                         label={t('investments.scheme')}
//                                         onChange={(e) => handleSchemeChange(i, e)}
//                                         onBlur={handleBlur}
//                                       >
//                                         <MenuItem value="">
//                                           <em>{t('common.select')}</em>
//                                         </MenuItem>
//                                         <MenuItem value="SB">{t('investments.sb')}</MenuItem>
//                                         <MenuItem value="FD">{t('investments.fd')}</MenuItem>
//                                         <MenuItem value="RD">{t('investments.rd')}</MenuItem>
//                                         <MenuItem value="PPF">{t('investments.ppf')}</MenuItem>
//                                         <MenuItem value="Other">{t('investments.other')}</MenuItem>
//                                       </Select>
//                                       {touched.investments?.[i]?.inv_scheme &&
//                                         errors.investments?.[i]?.inv_scheme && (
//                                           <Typography color="error" variant="caption" sx={{ ml: 2 }}>
//                                             {errors.investments[i].inv_scheme}
//                                           </Typography>
//                                         )}
//                                     </FormControl>
//                                   ) : (
//                                     <TextField
//                                       label={`${t('investments.specifyScheme')} *`}
//                                       name={`investments[${i}].inv_scheme`}
//                                       value={inv.inv_scheme || ""}
//                                       onChange={handleChange}
//                                       onBlur={handleBlur}
//                                       fullWidth
//                                       error={
//                                         touched.investments?.[i]?.inv_scheme &&
//                                         Boolean(errors.investments?.[i]?.inv_scheme)
//                                       }
//                                       helperText={
//                                         touched.investments?.[i]?.inv_scheme &&
//                                         errors.investments?.[i]?.inv_scheme
//                                       }
//                                       InputProps={{
//                                         endAdornment: (
//                                           <Button
//                                             onClick={() =>
//                                               setShowOtherScheme((prev) => {
//                                                 const newState = [...prev];
//                                                 newState[i] = false;
//                                                 return newState;
//                                               })
//                                             }
//                                             size="small"
//                                             sx={{ ml: 1 }}
//                                           >
//                                             {t('common.change')}
//                                           </Button>
//                                         ),
//                                       }}
//                                     />
//                                   )}
//                                 </Box>
//                                 <TextField
//                                   label={`${t('investments.amount')} *`}
//                                   name={`investments[${i}].inv_amt`}
//                                   value={inv.inv_amt}
//                                   onChange={handleChange}
//                                   onBlur={handleBlur}
//                                   error={
//                                     touched.investments?.[i]?.inv_amt &&
//                                     Boolean(errors.investments?.[i]?.inv_amt)
//                                   }
//                                   helperText={
//                                     touched.investments?.[i]?.inv_amt &&
//                                     errors.investments?.[i]?.inv_amt
//                                   }
//                                   fullWidth
//                                 />
//                               </TwoFieldRow>

//                               <TwoFieldRow>
//                                 <Box sx={{ flex: 1 }}>
//                                   <UploadWithLabel
//                                     label={t('investments.uploadProof')}
//                                     name={`investments[${i}].inv_proof`}
//                                     onChange={(e) => {
//                                       setFieldValue(`investments[${i}].inv_proof`, e.currentTarget.files[0]);
//                                       setFieldTouched(`investments[${i}].inv_proof`, true);
//                                     }}
//                                     file={inv.inv_proof}
//                                     error={
//                                       touched.investments?.[i]?.inv_proof &&
//                                       Boolean(errors.investments?.[i]?.inv_proof)
//                                     }
//                                     helperText={
//                                       touched.investments?.[i]?.inv_proof &&
//                                       errors.investments?.[i]?.inv_proof
//                                     }
//                                   />
//                                 </Box>
//                               </TwoFieldRow>

//                               <Button
//                                 variant="outlined"
//                                 color="error"
//                                 onClick={() => remove(i)}
//                                 sx={{ mt: 1 }}
//                               >
//                                 {t('common.remove')}
//                               </Button>
//                             </Box>
//                           );
//                         })}

//                         <Button
//                           variant="contained"
//                           sx={{ mt: 2 }}
//                           onClick={() =>
//                             push({
//                               investmentMode: "NEFT",
//                               inv_account_no: "",
//                               inv_ifsc_code: "",
//                               inv_bank_name: "",
//                               inv_branch_name: "",
//                               inv_scheme: "",
//                               inv_amt: "",
//                               inv_proof: null,
//                             })
//                           }
//                         >
//                           {t('investments.addInvestment')}
//                         </Button>

//                         <Box
//                           sx={{
//                             mt: 4,
//                             p: 2,
//                             border: "1px solid #999",
//                             borderRadius: 2,
//                             backgroundColor: "#f9f9f9",
//                           }}
//                         >
//                           <Typography variant="h6" gutterBottom>
//                             {t('investments.summary')}
//                           </Typography>
//                           <TextField
//                             label={t('investments.totalInvestmentAmount')}
//                             value={totalInvestment.toFixed(2)}
//                             InputProps={{ readOnly: true }}
//                             fullWidth
//                           />
//                         </Box>
//                       </>
//                     )}
//                   </FieldArray>

//                   <Box mt={1} sx={{ display: "flex", justifyContent: "space-between" }}>
//                     <Button
//                       variant="outlined"
//                       onClick={() => activeTab > 0 && setActiveTab(activeTab - 1)}
//                     >
//                       {t('common.back')}
//                     </Button>
//                     <Button type="submit" variant="contained" disabled={!isValid}>
//                       {t('common.next')}
//                     </Button>
//                   </Box>
//                 </Stack>
//               </Form>
//             </Paper>
//           </Container>
//         );
//       }}
//     </Formik>
//   );
// };

// export default InvestmentsSection;



// import React from "react";
// import {
//   Box,
//   TextField,
//   Button,
//   Typography,
//   MenuItem,
//   Container,
//   Paper,
//   Stack,
//   FormControl,
//   InputLabel,
//   Select,
// } from "@mui/material";
// import { Formik, Form, FieldArray, useFormikContext } from "formik";
// import * as Yup from "yup";
// import TwoFieldRow from "./twoFieldsRow";
// import UploadWithLabel from "./uploadWithLable";
// import { useTranslation } from "react-i18next";

// const investmentValidationSchema = Yup.object({
//   investments: Yup.array()
//     .of(
//       Yup.object({
//         investmentMode: Yup.string().required("Investment Mode is required"),
//         inv_account_no: Yup.string()
//           .matches(/^\d+$/, "Account number must contain only digits")
//           .min(6, "Account number must be at least 6 digits")
//           .max(18, "Account number must not exceed 18 digits")
//           .when("investmentMode", {
//             is: (value) => !["Cash"].includes(value),
//             then: (schema) => schema.required("Investment Account No is required"),
//             otherwise: (schema) => schema.notRequired(),
//           }),
//         inv_ifsc_code: Yup.string()
//           .matches(
//             /^[A-Z]{4}0[A-Z0-9]{6}$/,
//             "IFSC must be 11 characters (4 letters, 0, 6 alphanumeric)"
//           )
//           .when("investmentMode", {
//             is: (value) => !["Cash"].includes(value),
//             then: (schema) => schema.required("IFSC Code is required"),
//             otherwise: (schema) => schema.notRequired(),
//           }),
//         inv_bank_name: Yup.string()
//           .matches(/^[a-zA-Z\s]+$/, "Bank name must contain only letters and spaces")
//           .min(2, "Bank name must be at least 2 characters")
//           .when("investmentMode", {
//             is: (value) => !["Cash"].includes(value),
//             then: (schema) => schema.required("Bank Name is required"),
//             otherwise: (schema) => schema.notRequired(),
//           }),
//         inv_branch_name: Yup.string()
//           .matches(/^[a-zA-Z\s]+$/, "Branch name must contain only letters and spaces")
//           .min(2, "Branch name must be at least 2 characters")
//           .when("investmentMode", {
//             is: (value) => !["Cash"].includes(value),
//             then: (schema) => schema.required("Branch Name is required"),
//             otherwise: (schema) => schema.notRequired(),
//           }),
//         inv_scheme: Yup.string()
//           .required("Scheme is required")
//           .test("customScheme", "Specify scheme is required", (value) =>
//             typeof value === "string" && value.trim().length > 0
//           ),
//         inv_amt: Yup.number()
//           .typeError("Amount must be a number")
//           .positive("Amount must be positive")
//           .required("Amount is required"),
//         inv_proof: Yup.mixed()
//           .required("Bond/Statement is required")
//           .test(
//             "fileType",
//             "Only PDF files are allowed",
//             (value) => !value || value.name.toLowerCase().endsWith('.pdf')
//           )
//           .test(
//             "fileExists",
//             "Proof is required",
//             (value) => value && typeof value.name === "string" && value.name.length > 0
//           )
//           .test(
//             "fileSize",
//             "File size must be less than 2MB",
//             (value) => !value || value.size <= 2 * 1024 * 1024
//           ),
//       })
//     )
//     .min(1, "At least one investment is required"),
// });

// const TotalWatcher = ({ onTotalAmountChange }) => {
//   const { values } = useFormikContext();

//   React.useEffect(() => {
//     if (values.investments) {
//       const total = values.investments.reduce(
//         (sum, inv) => sum + (Number(inv.inv_amt) || 0),
//         0
//       );
//       onTotalAmountChange && onTotalAmountChange(total);
//     }
//   }, [values.investments, onTotalAmountChange]);

//   return null;
// };

// const InvestmentsSection = ({
//   investments,
//   setInvestments,
//   activeTab,
//   setActiveTab,
//   onTotalAmountChange,
// }) => {
//   const { t } = useTranslation();

//   const selectFormControlSX = {
//     minWidth: 200,
//     maxWidth: "100%",
//   };

//   const [showOtherScheme, setShowOtherScheme] = React.useState([]);

//   React.useEffect(() => {
//     // Initialize showOtherScheme based on existing investments
//     const initialShowOtherScheme = investments.map(inv => inv.inv_scheme === "Other");
//     setShowOtherScheme(initialShowOtherScheme);
//   }, [investments]);

//   const initialValues = {
//     investments: investments?.length > 0 
//       ? investments.map(inv => ({
//           ...inv,
//           investmentMode: inv.investmentMode || "NEFT",
//         }))
//       : [{
//           investmentMode: "NEFT",
//           inv_account_no: "",
//           inv_ifsc_code: "",
//           inv_bank_name: "",
//           inv_branch_name: "",
//           inv_scheme: "",
//           inv_amt: "",
//           inv_proof: null,
//         }]
//   };

//   return (
//     <Formik
//       initialValues={initialValues}
//       validationSchema={investmentValidationSchema}
//       enableReinitialize
//       onSubmit={(values) => {
//         setInvestments(values.investments);
//         setActiveTab(activeTab + 1);
//       }}
//     >
//       {({
//         values,
//         errors,
//         touched,
//         handleChange,
//         handleBlur,
//         setFieldValue,
//         setFieldTouched,
//         isValid,
//         validateForm,
//         submitForm,
//       }) => {
//         const handleSchemeChange = (i, e) => {
//           const val = e.target.value;
//           if (val === "Other") {
//             setShowOtherScheme((prev) => {
//               const newState = [...prev];
//               newState[i] = true;
//               return newState;
//             });
//             setFieldValue(`investments[${i}].inv_scheme`, "");
//             setFieldTouched(`investments[${i}].inv_scheme`, false);
//           } else {
//             setFieldValue(`investments[${i}].inv_scheme`, val);
//             setShowOtherScheme((prev) => {
//               const newState = [...prev];
//               newState[i] = false;
//               return newState;
//             });
//           }
//         };

//         const handleSubmit = async (e) => {
//           e.preventDefault();
          
//           // Validate all fields and show errors
//           await validateForm();
          
//           // Check if form is valid by checking if there are any errors
//           const isFormValid = Object.keys(errors).length === 0;
          
//           if (isFormValid) {
//             submitForm();
//           } else {
//             // Touch all fields to show validation errors
//             const touchedFields = {};
//             values.investments.forEach((_, index) => {
//               touchedFields[`investments[${index}].investmentMode`] = true;
//               touchedFields[`investments[${index}].inv_account_no`] = true;
//               touchedFields[`investments[${index}].inv_ifsc_code`] = true;
//               touchedFields[`investments[${index}].inv_bank_name`] = true;
//               touchedFields[`investments[${index}].inv_branch_name`] = true;
//               touchedFields[`investments[${index}].inv_scheme`] = true;
//               touchedFields[`investments[${index}].inv_amt`] = true;
//               touchedFields[`investments[${index}].inv_proof`] = true;
//             });
            
//             // Manually trigger validation display
//             Object.keys(touchedFields).forEach(field => {
//               setFieldTouched(field, true, false);
//             });
//           }
//         };

//         const totalInvestment = values.investments.reduce(
//           (sum, inv) => sum + (Number(inv.inv_amt) || 0),
//           0
//         );

//         return (
//           <Container maxWidth={false} sx={{ mt: 5, maxWidth: 800 }}>
//             <Paper elevation={4} sx={{ p: 4, borderRadius: 3 }}>
//               <Typography variant="h4" fontWeight="700" color="primary.main" gutterBottom>
//                 {t('investments.heading')}
//               </Typography>
//               <Form noValidate>
//                 <Stack spacing={3}>
//                   <TotalWatcher onTotalAmountChange={onTotalAmountChange} />
                  
//                   <FieldArray name="investments">
//                     {({ remove, push }) => (
//                       <>
//                         {values.investments.map((inv, i) => {
//                           const isCashMode = inv.investmentMode === "Cash";
                          
//                           return (
//                             <Box
//                               key={i}
//                               mb={2}
//                               p={2}
//                               sx={{ border: "1px solid #ccc", borderRadius: 2 }}
//                             >
//                               {/* Investment Mode for each investment */}
//                               <FormControl 
//                                 fullWidth 
//                                 error={touched.investments?.[i]?.investmentMode && Boolean(errors.investments?.[i]?.investmentMode)}
//                                 sx={{ mb: 2 }}
//                               >
//                                 <InputLabel id={`investment_mode_label_${i}`}>
//                                   {'Investment Mode'}
//                                 </InputLabel>
//                                 <Select
//                                   labelId={`investment_mode_label_${i}`}
//                                   name={`investments[${i}].investmentMode`}
//                                   value={inv.investmentMode || "NEFT"}
//                                   label={'Investment Mode'}
//                                   onChange={handleChange}
//                                   onBlur={handleBlur}
//                                 >
//                                   <MenuItem value="Cash">Cash</MenuItem>
//                                   <MenuItem value="NEFT">NEFT</MenuItem>
//                                   <MenuItem value="Cheque">Cheque</MenuItem>
//                                   <MenuItem value="RTGS">RTGS</MenuItem>
//                                   <MenuItem value="IMPS">IMPS</MenuItem>
//                                   <MenuItem value="Other">Other</MenuItem>
//                                 </Select>
//                                 {touched.investments?.[i]?.investmentMode && errors.investments?.[i]?.investmentMode && (
//                                   <Typography color="error" variant="caption">
//                                     {errors.investments[i].investmentMode}
//                                   </Typography>
//                                 )}
//                               </FormControl>

//                               {/* Bank Details - Hidden for Cash */}
//                               {!isCashMode && (
//                                 <>
//                                   <TwoFieldRow>
//                                     <TextField
//                                       label={`${t('investments.invAccountNo')} *`}
//                                       name={`investments[${i}].inv_account_no`}
//                                       value={inv.inv_account_no}
//                                       onChange={handleChange}
//                                       onBlur={handleBlur}
//                                       error={
//                                         touched.investments?.[i]?.inv_account_no &&
//                                         Boolean(errors.investments?.[i]?.inv_account_no)
//                                       }
//                                       helperText={
//                                         touched.investments?.[i]?.inv_account_no &&
//                                         errors.investments?.[i]?.inv_account_no
//                                       }
//                                       fullWidth
//                                     />
//                                     <TextField
//                                       label={`${t('investments.ifscCode')} *`}
//                                       name={`investments[${i}].inv_ifsc_code`}
//                                       value={inv.inv_ifsc_code}
//                                       onChange={handleChange}
//                                       onBlur={handleBlur}
//                                       error={
//                                         touched.investments?.[i]?.inv_ifsc_code &&
//                                         Boolean(errors.investments?.[i]?.inv_ifsc_code)
//                                       }
//                                       helperText={
//                                         touched.investments?.[i]?.inv_ifsc_code &&
//                                         errors.investments?.[i]?.inv_ifsc_code
//                                       }
//                                       fullWidth
//                                     />
//                                   </TwoFieldRow>

//                                   <TwoFieldRow>
//                                     <TextField
//                                       label={`${t('investments.bankName')} *`}
//                                       name={`investments[${i}].inv_bank_name`}
//                                       value={inv.inv_bank_name}
//                                       onChange={handleChange}
//                                       onBlur={handleBlur}
//                                       error={
//                                         touched.investments?.[i]?.inv_bank_name &&
//                                         Boolean(errors.investments?.[i]?.inv_bank_name)
//                                       }
//                                       helperText={
//                                         touched.investments?.[i]?.inv_bank_name &&
//                                         errors.investments?.[i]?.inv_bank_name
//                                       }
//                                       fullWidth
//                                     />
//                                     <TextField
//                                       label={`${t('investments.branchName')} *`}
//                                       name={`investments[${i}].inv_branch_name`}
//                                       value={inv.inv_branch_name}
//                                       onChange={handleChange}
//                                       onBlur={handleBlur}
//                                       error={
//                                         touched.investments?.[i]?.inv_branch_name &&
//                                         Boolean(errors.investments?.[i]?.inv_branch_name)
//                                       }
//                                       helperText={
//                                         touched.investments?.[i]?.inv_branch_name &&
//                                         errors.investments?.[i]?.inv_branch_name
//                                       }
//                                       fullWidth
//                                     />
//                                   </TwoFieldRow>
//                                 </>
//                               )}

//                               <TwoFieldRow>
//                                 <Box sx={{ minWidth: 200, flex: 1 }}>
//                                   {!showOtherScheme[i] ? (
//                                     <FormControl
//                                       fullWidth
//                                       margin="normal"
//                                       error={
//                                         touched.investments?.[i]?.inv_scheme &&
//                                         Boolean(errors.investments?.[i]?.inv_scheme)
//                                       }
//                                       sx={selectFormControlSX}
//                                     >
//                                       <InputLabel id={`inv_scheme_label_${i}`}>
//                                         {t('investments.scheme')}
//                                       </InputLabel>
//                                       <Select
//                                         labelId={`inv_scheme_label_${i}`}
//                                         name={`investments[${i}].inv_scheme`}
//                                         value={inv.inv_scheme || ""}
//                                         label={t('investments.scheme')}
//                                         onChange={(e) => handleSchemeChange(i, e)}
//                                         onBlur={handleBlur}
//                                       >
//                                         <MenuItem value="">
//                                           <em>{t('common.select')}</em>
//                                         </MenuItem>
//                                         <MenuItem value="SB">{t('investments.sb')}</MenuItem>
//                                         <MenuItem value="FD">{t('investments.fd')}</MenuItem>
//                                         <MenuItem value="RD">{t('investments.rd')}</MenuItem>
//                                         <MenuItem value="PPF">{t('investments.ppf')}</MenuItem>
//                                         <MenuItem value="Other">{t('investments.other')}</MenuItem>
//                                       </Select>
//                                       {touched.investments?.[i]?.inv_scheme &&
//                                         errors.investments?.[i]?.inv_scheme && (
//                                           <Typography color="error" variant="caption" sx={{ ml: 2 }}>
//                                             {errors.investments[i].inv_scheme}
//                                           </Typography>
//                                         )}
//                                     </FormControl>
//                                   ) : (
//                                     <TextField
//                                       label={`${t('investments.specifyScheme')} *`}
//                                       name={`investments[${i}].inv_scheme`}
//                                       value={inv.inv_scheme || ""}
//                                       onChange={handleChange}
//                                       onBlur={handleBlur}
//                                       fullWidth
//                                       error={
//                                         touched.investments?.[i]?.inv_scheme &&
//                                         Boolean(errors.investments?.[i]?.inv_scheme)
//                                       }
//                                       helperText={
//                                         touched.investments?.[i]?.inv_scheme &&
//                                         errors.investments?.[i]?.inv_scheme
//                                       }
//                                       InputProps={{
//                                         endAdornment: (
//                                           <Button
//                                             onClick={() => {
//                                               setShowOtherScheme((prev) => {
//                                                 const newState = [...prev];
//                                                 newState[i] = false;
//                                                 return newState;
//                                               });
//                                               setFieldValue(`investments[${i}].inv_scheme`, "");
//                                             }}
//                                             size="small"
//                                             sx={{ ml: 1 }}
//                                           >
//                                             {t('common.change')}
//                                           </Button>
//                                         ),
//                                       }}
//                                     />
//                                   )}
//                                 </Box>
//                                 <TextField
//                                   label={`${t('investments.amount')} *`}
//                                   name={`investments[${i}].inv_amt`}
//                                   value={inv.inv_amt}
//                                   onChange={handleChange}
//                                   onBlur={handleBlur}
//                                   error={
//                                     touched.investments?.[i]?.inv_amt &&
//                                     Boolean(errors.investments?.[i]?.inv_amt)
//                                   }
//                                   helperText={
//                                     touched.investments?.[i]?.inv_amt &&
//                                     errors.investments?.[i]?.inv_amt
//                                   }
//                                   fullWidth
//                                 />
//                               </TwoFieldRow>

//                               <TwoFieldRow>
//                                 <Box sx={{ flex: 1 }}>
//                                   <UploadWithLabel
//                                     label={t('investments.uploadProof')}
//                                     name={`investments[${i}].inv_proof`}
//                                     onChange={(e) => {
//                                       setFieldValue(`investments[${i}].inv_proof`, e.currentTarget.files[0]);
//                                       setFieldTouched(`investments[${i}].inv_proof`, true);
//                                     }}
//                                     file={inv.inv_proof}
//                                     error={
//                                       touched.investments?.[i]?.inv_proof &&
//                                       Boolean(errors.investments?.[i]?.inv_proof)
//                                     }
//                                     helperText={
//                                       touched.investments?.[i]?.inv_proof &&
//                                       errors.investments?.[i]?.inv_proof
//                                     }
//                                   />
//                                 </Box>
//                               </TwoFieldRow>

//                               <Button
//                                 variant="outlined"
//                                 color="error"
//                                 onClick={() => remove(i)}
//                                 sx={{ mt: 1 }}
//                               >
//                                 {t('common.remove')}
//                               </Button>
//                             </Box>
//                           );
//                         })}

//                         <Button
//                           variant="contained"
//                           sx={{ mt: 2 }}
//                           onClick={() => {
//                             push({
//                               investmentMode: "NEFT",
//                               inv_account_no: "",
//                               inv_ifsc_code: "",
//                               inv_bank_name: "",
//                               inv_branch_name: "",
//                               inv_scheme: "",
//                               inv_amt: "",
//                               inv_proof: null,
//                             });
//                             // Add new entry to showOtherScheme array
//                             setShowOtherScheme(prev => [...prev, false]);
//                           }}
//                         >
//                           {t('investments.addInvestment')}
//                         </Button>

//                         <Box
//                           sx={{
//                             mt: 4,
//                             p: 2,
//                             border: "1px solid #999",
//                             borderRadius: 2,
//                             backgroundColor: "#f9f9f9",
//                           }}
//                         >
//                           <Typography variant="h6" gutterBottom>
//                             {t('investments.summary')}
//                           </Typography>
//                           <TextField
//                             label={t('investments.totalInvestmentAmount')}
//                             value={totalInvestment.toFixed(2)}
//                             InputProps={{ readOnly: true }}
//                             fullWidth
//                           />
//                         </Box>
//                       </>
//                     )}
//                   </FieldArray>

//                   <Box mt={1} sx={{ display: "flex", justifyContent: "space-between" }}>
//                     <Button
//                       variant="outlined"
//                       onClick={() => activeTab > 0 && setActiveTab(activeTab - 1)}
//                     >
//                       {t('common.back')}
//                     </Button>
//                     <Button 
//                       type="button" 
//                       variant="contained"
//                       onClick={handleSubmit}
//                     >
//                       {t('common.next')}
//                     </Button>
//                   </Box>
//                 </Stack>
//               </Form>
//             </Paper>
//           </Container>
//         );
//       }}
//     </Formik>
//   );
// };

// export default InvestmentsSection;

// import React from "react";
// import {
//   Box,
//   TextField,
//   Button,
//   Typography,
//   MenuItem,
//   Container,
//   Paper,
//   Stack,
//   FormControl,
//   InputLabel,
//   Select,
// } from "@mui/material";
// import { Formik, Form, FieldArray, useFormikContext } from "formik";
// import * as Yup from "yup";
// import TwoFieldRow from "./twoFieldsRow";
// import UploadWithLabel from "./uploadWithLable";
// import { useTranslation } from "react-i18next";

// const investmentValidationSchema = Yup.object({
//   investments: Yup.array()
//     .of(
//       Yup.object({
//         investmentMode: Yup.string().required("Investment Mode is required"),
//         inv_account_no: Yup.string()
//           .matches(/^\d+$/, "Account number must contain only digits")
//           .min(2, "Account number must be at least 2 digits")
//           .max(18, "Account number must not exceed 18 digits")
//           .when("investmentMode", {
//             is: (value) => !["Cash"].includes(value),
//             then: (schema) => schema.required("Investment Account No is required"),
//             otherwise: (schema) => schema.notRequired(),
//           }),
//         // inv_ifsc_code: Yup.string()
//         //   .matches(
//         //     /^[A-Z]{4}0[A-Z0-9]{6}$/,
//         //     "IFSC must be 11 characters (4 letters, 0, 6 alphanumeric)"
//         //   )
//         inv_ifsc_code: Yup.string()
//           .matches(
//             /^(NA|[A-Za-z0-9]+)$/,
//             "IFSC can be NA or any alphanumeric characters"
//           )

//           .when("investmentMode", {
//             is: (value) => !["Cash"].includes(value),
//             then: (schema) => schema.required("IFSC Code is required"),
//             otherwise: (schema) => schema.notRequired(),
//           }),
//         inv_bank_name: Yup.string()
//           // .matches(/^[a-zA-Z\s]+$/, "Bank name must contain only letters and spaces")
//           .matches(/^.*$/, "Bank name is required")
//           .min(2, "Bank name must be at least 2 characters")
//           .when("investmentMode", {
//             is: (value) => !["Cash"].includes(value),
//             then: (schema) => schema.required("Bank Name is required"),
//             otherwise: (schema) => schema.notRequired(),
//           }),
//         inv_branch_name: Yup.string()
//           .matches(/^[a-zA-Z\s]+$/, "Branch name must contain only letters and spaces")
//           .min(2, "Branch name must be at least 2 characters")
//           .when("investmentMode", {
//             is: (value) => !["Cash"].includes(value),
//             then: (schema) => schema.required("Branch Name is required"),
//             otherwise: (schema) => schema.notRequired(),
//           }),
//         inv_scheme: Yup.string()
//           .required("Scheme is required")
//           .test("customScheme", "Specify scheme is required", (value) =>
//             typeof value === "string" && value.trim().length > 0
//           ),
//         inv_amt: Yup.number()
//           .typeError("Amount must be a number")
//           .positive("Amount must be positive")
//           .required("Amount is required"),
//         inv_proof: Yup.mixed()
//           .required("Bond/Statement is required")
//           .test(
//             "fileType",
//             "Only PDF files are allowed",
//             (value) => !value || value.name.toLowerCase().endsWith('.pdf')
//           )
//           .test(
//             "fileExists",
//             "Proof is required",
//             (value) => value && typeof value.name === "string" && value.name.length > 0
//           )
//           .test(
//             "fileSize",
//             "File size must be less than 2MB",
//             (value) => !value || value.size <= 2 * 1024 * 1024
//           ),
//       })
//     )
//     .min(1, "At least one investment is required"),
// });

// const TotalWatcher = ({ onTotalAmountChange }) => {
//   const { values } = useFormikContext();

//   React.useEffect(() => {
//     if (values.investments) {
//       const total = values.investments.reduce(
//         (sum, inv) => sum + (Number(inv.inv_amt) || 0),
//         0
//       );
//       onTotalAmountChange && onTotalAmountChange(total);
//     }
//   }, [values.investments, onTotalAmountChange]);

//   return null;
// };

// const InvestmentsSection = ({
//   FE,
//   investments,
//   setInvestments,
//   activeTab,
//   setActiveTab,
//   onTotalAmountChange,
// }) => {
//   const { t } = useTranslation();

//   const selectFormControlSX = {
//     minWidth: 200,
//     maxWidth: "100%",
//   };

//   const [showOtherScheme, setShowOtherScheme] = React.useState([]);

//   React.useEffect(() => {
//     // Initialize showOtherScheme based on existing investments
//     const initialShowOtherScheme = investments.map(inv => inv.inv_scheme === "Other");
//     setShowOtherScheme(initialShowOtherScheme);
//   }, [investments]);

//   const initialValues = {
//     investments: investments?.length > 0 
//       ? investments.map(inv => ({
//           ...inv,
//           investmentMode: inv.investmentMode || "NEFT",
//           inv_bank_name: FE,
//         }))
//       : [{
//           investmentMode: "NEFT",
//           inv_account_no: "",
//           inv_ifsc_code: "",
//           inv_bank_name: FE,
//           inv_branch_name: "",
//           inv_scheme: "",
//           inv_amt: "",
//           inv_proof: null,
//         }]
//   };

//   return (
//     <Formik
//       initialValues={initialValues}
//       validationSchema={investmentValidationSchema}
//       enableReinitialize
//       onSubmit={(values) => {
//         setInvestments(values.investments);
//         setActiveTab(activeTab + 1);
//       }}
//     >
//       {({
//         values,
//         errors,
//         touched,
//         handleChange,
//         handleBlur,
//         setFieldValue,
//         setFieldTouched,
//         isValid,
//         validateForm,
//         submitForm,
//       }) => {
//         const handleSchemeChange = (i, e) => {
//           const val = e.target.value;
//           if (val === "Other") {
//             setShowOtherScheme((prev) => {
//               const newState = [...prev];
//               newState[i] = true;
//               return newState;
//             });
//             setFieldValue(`investments[${i}].inv_scheme`, "");
//             setFieldTouched(`investments[${i}].inv_scheme`, false);
//           } else {
//             setFieldValue(`investments[${i}].inv_scheme`, val);
//             setShowOtherScheme((prev) => {
//               const newState = [...prev];
//               newState[i] = false;
//               return newState;
//             });
//           }
//         };

//         const handleSubmit = async (e) => {
//           e.preventDefault();
          
//           // Validate all fields and show errors
//           await validateForm();
          
//           // Check if form is valid by checking if there are any errors
//           const isFormValid = Object.keys(errors).length === 0;
          
//           if (isFormValid) {
//             submitForm();
//           } else {
//             // Touch all fields to show validation errors
//             const touchedFields = {};
//             values.investments.forEach((_, index) => {
//               touchedFields[`investments[${index}].investmentMode`] = true;
//               touchedFields[`investments[${index}].inv_account_no`] = true;
//               touchedFields[`investments[${index}].inv_ifsc_code`] = true;
//               touchedFields[`investments[${index}].inv_bank_name`] = true;
//               touchedFields[`investments[${index}].inv_branch_name`] = true;
//               touchedFields[`investments[${index}].inv_scheme`] = true;
//               touchedFields[`investments[${index}].inv_amt`] = true;
//               touchedFields[`investments[${index}].inv_proof`] = true;
//             });
            
//             // Manually trigger validation display
//             Object.keys(touchedFields).forEach(field => {
//               setFieldTouched(field, true, false);
//             });
//           }
//         };

//         const totalInvestment = values.investments.reduce(
//           (sum, inv) => sum + (Number(inv.inv_amt) || 0),
//           0
//         );

//         return (
//           <Container maxWidth={false} sx={{ mt: 5, maxWidth: 800 }}>
//             <Paper elevation={4} sx={{ p: 4, borderRadius: 3 }}>
//               <Typography variant="h4" fontWeight="700" color="primary.main" gutterBottom>
//                 {t('investments.heading')}
//               </Typography>
//               <Form noValidate>
//                 <Stack spacing={3}>
//                   <TotalWatcher onTotalAmountChange={onTotalAmountChange} />
                  
//                   <FieldArray name="investments">
//                     {({ remove, push }) => (
//                       <>
//                         {values.investments.map((inv, i) => {
//                           const isCashMode = inv.investmentMode === "Cash";
                          
//                           return (
//                             <Box
//                               key={i}
//                               mb={2}
//                               p={2}
//                               sx={{ border: "1px solid #ccc", borderRadius: 2 }}
//                             >
//                               {/* Investment Mode for each investment */}
//                               <FormControl 
//                                 fullWidth 
//                                 error={touched.investments?.[i]?.investmentMode && Boolean(errors.investments?.[i]?.investmentMode)}
//                                 sx={{ mb: 2 }}
//                               >
//                                 <InputLabel id={`investment_mode_label_${i}`}>
//                                   {'Investment Mode'}
//                                 </InputLabel>
//                                 <Select
//                                   labelId={`investment_mode_label_${i}`}
//                                   name={`investments[${i}].investmentMode`}
//                                   value={inv.investmentMode || "NEFT"}
//                                   label={'Investment Mode'}
//                                   onChange={handleChange}
//                                   onBlur={handleBlur}
//                                 >
//                                   <MenuItem value="Cash">Cash</MenuItem>
//                                   <MenuItem value="NEFT">NEFT</MenuItem>
//                                   <MenuItem value="Cheque">Cheque</MenuItem>
//                                   <MenuItem value="RTGS">RTGS</MenuItem>
//                                   <MenuItem value="IMPS">IMPS</MenuItem>
//                                   <MenuItem value="Other">Other</MenuItem>
//                                 </Select>
//                                 {touched.investments?.[i]?.investmentMode && errors.investments?.[i]?.investmentMode && (
//                                   <Typography color="error" variant="caption">
//                                     {errors.investments[i].investmentMode}
//                                   </Typography>
//                                 )}
//                               </FormControl>

//                               {/* Bank Details - Hidden for Cash */}
//                               {!isCashMode && (
//                                 <>
//                                   <TwoFieldRow>
//                                     <TextField
//                                       label={`${t('investments.invAccountNo')} *`}
//                                       name={`investments[${i}].inv_account_no`}
//                                       value={inv.inv_account_no}
//                                       onChange={handleChange}
//                                       onBlur={handleBlur}
//                                       error={
//                                         touched.investments?.[i]?.inv_account_no &&
//                                         Boolean(errors.investments?.[i]?.inv_account_no)
//                                       }
//                                       helperText={
//                                         touched.investments?.[i]?.inv_account_no &&
//                                         errors.investments?.[i]?.inv_account_no
//                                       }
//                                       fullWidth
//                                     />
//                                     <TextField
//                                       label={`${t('investments.ifscCode')} *`}
//                                       name={`investments[${i}].inv_ifsc_code`}
//                                       value={inv.inv_ifsc_code}
//                                       onChange={handleChange}
//                                       onBlur={handleBlur}
//                                       error={
//                                         touched.investments?.[i]?.inv_ifsc_code &&
//                                         Boolean(errors.investments?.[i]?.inv_ifsc_code)
//                                       }
//                                       helperText={
//                                         touched.investments?.[i]?.inv_ifsc_code &&
//                                         errors.investments?.[i]?.inv_ifsc_code
//                                       }
//                                       fullWidth
//                                     />
//                                   </TwoFieldRow>

//                                   <TwoFieldRow>
//                                     <TextField
//                                       label={`${t('investments.bankName')} *`}
//                                       name={`investments[${i}].inv_bank_name`}
//                                       // value={inv.inv_bank_name}
//                                       value={inv.inv_bank_name || FE}
//                                       inputProps={{ readOnly: true }}
//                                       onChange={handleChange}
//                                       onBlur={handleBlur}
//                                       error={
//                                         touched.investments?.[i]?.inv_bank_name &&
//                                         Boolean(errors.investments?.[i]?.inv_bank_name)
//                                       }
//                                       helperText={
//                                         touched.investments?.[i]?.inv_bank_name &&
//                                         errors.investments?.[i]?.inv_bank_name
//                                       }
//                                       fullWidth
//                                     />
//                                     <TextField
//                                       label={`${t('investments.branchName')} *`}
//                                       name={`investments[${i}].inv_branch_name`}
//                                       value={inv.inv_branch_name}
//                                       onChange={handleChange}
//                                       onBlur={handleBlur}
//                                       error={
//                                         touched.investments?.[i]?.inv_branch_name &&
//                                         Boolean(errors.investments?.[i]?.inv_branch_name)
//                                       }
//                                       helperText={
//                                         touched.investments?.[i]?.inv_branch_name &&
//                                         errors.investments?.[i]?.inv_branch_name
//                                       }
//                                       fullWidth
//                                     />
//                                   </TwoFieldRow>
//                                 </>
//                               )}

//                               <TwoFieldRow>
//                                 <Box sx={{ minWidth: 200, flex: 1 }}>
//                                   {!showOtherScheme[i] ? (
//                                     <FormControl
//                                       fullWidth
//                                       margin="normal"
//                                       error={
//                                         touched.investments?.[i]?.inv_scheme &&
//                                         Boolean(errors.investments?.[i]?.inv_scheme)
//                                       }
//                                       sx={selectFormControlSX}
//                                     >
//                                       <InputLabel id={`inv_scheme_label_${i}`}>
//                                         {t('investments.scheme')}
//                                       </InputLabel>
//                                       <Select
//                                         labelId={`inv_scheme_label_${i}`}
//                                         name={`investments[${i}].inv_scheme`}
//                                         value={inv.inv_scheme || ""}
//                                         label={t('investments.scheme')}
//                                         onChange={(e) => handleSchemeChange(i, e)}
//                                         onBlur={handleBlur}
//                                       >
//                                         <MenuItem value="">
//                                           <em>{t('common.select')}</em>
//                                         </MenuItem>
//                                         <MenuItem value="SB">{t('investments.sb')}</MenuItem>
//                                         <MenuItem value="FD">{t('investments.fd')}</MenuItem>
//                                         <MenuItem value="RD">{t('investments.rd')}</MenuItem>
//                                         <MenuItem value="PPF">{t('investments.ppf')}</MenuItem>
//                                         <MenuItem value="Other">{t('investments.other')}</MenuItem>
//                                       </Select>
//                                       {touched.investments?.[i]?.inv_scheme &&
//                                         errors.investments?.[i]?.inv_scheme && (
//                                           <Typography color="error" variant="caption" sx={{ ml: 2 }}>
//                                             {errors.investments[i].inv_scheme}
//                                           </Typography>
//                                         )}
//                                     </FormControl>
//                                   ) : (
//                                     <TextField
//                                       label={`${t('investments.specifyScheme')} *`}
//                                       name={`investments[${i}].inv_scheme`}
//                                       value={inv.inv_scheme || ""}
//                                       onChange={handleChange}
//                                       onBlur={handleBlur}
//                                       fullWidth
//                                       error={
//                                         touched.investments?.[i]?.inv_scheme &&
//                                         Boolean(errors.investments?.[i]?.inv_scheme)
//                                       }
//                                       helperText={
//                                         touched.investments?.[i]?.inv_scheme &&
//                                         errors.investments?.[i]?.inv_scheme
//                                       }
//                                       InputProps={{
//                                         endAdornment: (
//                                           <Button
//                                             onClick={() => {
//                                               setShowOtherScheme((prev) => {
//                                                 const newState = [...prev];
//                                                 newState[i] = false;
//                                                 return newState;
//                                               });
//                                               setFieldValue(`investments[${i}].inv_scheme`, "");
//                                             }}
//                                             size="small"
//                                             sx={{ ml: 1 }}
//                                           >
//                                             {t('common.change')}
//                                           </Button>
//                                         ),
//                                       }}
//                                     />
//                                   )}
//                                 </Box>
//                                 <TextField
//                                   label={`${t('investments.amount')} *`}
//                                   name={`investments[${i}].inv_amt`}
//                                   value={inv.inv_amt}
//                                   onChange={handleChange}
//                                   onBlur={handleBlur}
//                                   error={
//                                     touched.investments?.[i]?.inv_amt &&
//                                     Boolean(errors.investments?.[i]?.inv_amt)
//                                   }
//                                   helperText={
//                                     touched.investments?.[i]?.inv_amt &&
//                                     errors.investments?.[i]?.inv_amt
//                                   }
//                                   fullWidth
//                                 />
//                               </TwoFieldRow>

//                               <TwoFieldRow>
//                                 <Box sx={{ flex: 1 }}>
//                                   <UploadWithLabel
//                                     label={t('investments.uploadProof')}
//                                     name={`investments[${i}].inv_proof`}
//                                     onChange={(e) => {
//                                       setFieldValue(`investments[${i}].inv_proof`, e.currentTarget.files[0]);
//                                       setFieldTouched(`investments[${i}].inv_proof`, true);
//                                     }}
//                                     file={inv.inv_proof}
//                                     error={
//                                       touched.investments?.[i]?.inv_proof &&
//                                       Boolean(errors.investments?.[i]?.inv_proof)
//                                     }
//                                     helperText={
//                                       touched.investments?.[i]?.inv_proof &&
//                                       errors.investments?.[i]?.inv_proof
//                                     }
//                                   />
//                                   {touched.investments?.[i]?.inv_proof && errors.investments?.[i]?.inv_proof && (
//                                     <Typography color="error" variant="caption" sx={{ ml: 2 }}>
//                                       {errors.investments[i].inv_proof}
//                                     </Typography>
//                                   )}
//                                 </Box>
//                               </TwoFieldRow>

//                               <Button
//                                 variant="outlined"
//                                 color="error"
//                                 onClick={() => remove(i)}
//                                 sx={{ mt: 1 }}
//                               >
//                                 {t('common.remove')}
//                               </Button>
//                             </Box>
//                           );
//                         })}

//                         <Button
//                           variant="contained"
//                           sx={{ mt: 2 }}
//                           onClick={() => {
//                             push({
//                               investmentMode: "NEFT",
//                               inv_account_no: "",
//                               inv_ifsc_code: "",
//                               inv_bank_name: FE,
//                               inv_branch_name: "",
//                               inv_scheme: "",
//                               inv_amt: "",
//                               inv_proof: null,
//                             });
//                             // Add new entry to showOtherScheme array
//                             setShowOtherScheme(prev => [...prev, false]);
//                           }}
//                         >
//                           {t('investments.addInvestment')}
//                         </Button>

//                         <Box
//                           sx={{
//                             mt: 4,
//                             p: 2,
//                             border: "1px solid #999",
//                             borderRadius: 2,
//                             backgroundColor: "#f9f9f9",
//                           }}
//                         >
//                           <Typography variant="h6" gutterBottom>
//                             {t('investments.summary')}
//                           </Typography>
//                           <TextField
//                             label={t('investments.totalInvestmentAmount')}
//                             value={totalInvestment.toFixed(2)}
//                             InputProps={{ readOnly: true }}
//                             fullWidth
//                           />
//                         </Box>
//                       </>
//                     )}
//                   </FieldArray>

//                   <Box mt={1} sx={{ display: "flex", justifyContent: "space-between" }}>
//                     <Button
//                       variant="outlined"
//                       onClick={() => activeTab > 0 && setActiveTab(activeTab - 1)}
//                     >
//                       {t('common.back')}
//                     </Button>
//                     <Button 
//                       type="button" 
//                       variant="contained"
//                       onClick={handleSubmit}
//                     >
//                       {t('common.next')}
//                     </Button>
//                   </Box>
//                 </Stack>
//               </Form>
//             </Paper>
//           </Container>
//         );
//       }}
//     </Formik>
//   );
// };

// export default InvestmentsSection;


import React from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  MenuItem,
  Container,
  Paper,
  Stack,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import { Formik, Form, FieldArray, useFormikContext } from "formik";
import * as Yup from "yup";
import TwoFieldRow from "./twoFieldsRow";
import UploadWithLabel from "./uploadWithLable";
import { useTranslation } from "react-i18next";

const investmentValidationSchema = Yup.object({
  investments: Yup.array()
    .of(
      Yup.object({
        investmentMode: Yup.string().required("Investment Mode is required"),
        inv_account_no: Yup.string()
          .matches(/^\d+$|^Cash\d+$/, "Account number must contain only digits or Cash format")
          .min(2, "Account number must be at least 2 characters")
          .max(18, "Account number must not exceed 18 characters")
          .required("Investment Account No is required"),
        inv_ifsc_code: Yup.string()
          .matches(/^(NA|[A-Za-z0-9]+)$/, "IFSC can be NA or alphanumeric characters")
          .required("IFSC Code is required"),
        inv_bank_name: Yup.string()
          .matches(/^.*$/, "Bank name is required")
          .min(2, "Bank name must be at least 2 characters")
          .required("Bank Name is required"),
        inv_branch_name: Yup.string()
          .matches(/^(NA|[a-zA-Z\s]+)$/, "Branch name must be NA or contain only letters and spaces")
          .min(2, "Branch name must be at least 2 characters")
          .required("Branch Name is required"),
        inv_scheme: Yup.string()
          .required("Scheme is required")
          .test("customScheme", "Specify scheme is required", (value) =>
            typeof value === "string" && value.trim().length > 0
          ),
        inv_amt: Yup.number()
          .typeError("Amount must be a number")
          .positive("Amount must be positive")
          .required("Amount is required"),
        inv_proof: Yup.mixed()
          .required("Bond/Statement is required")
          .test(
            "fileType",
            "Only PDF files are allowed",
            (value) => !value || value.name.toLowerCase().endsWith('.pdf')
          )
          .test(
            "fileExists",
            "Proof is required",
            (value) => value && typeof value.name === "string" && value.name.length > 0
          )
          .test(
            "fileSize",
            "File size must be less than 2MB",
            (value) => !value || value.size <= 2 * 1024 * 1024
          ),
      })
    )
    .min(1, "At least one investment is required"),
});

const TotalWatcher = ({ onTotalAmountChange }) => {
  const { values } = useFormikContext();

  React.useEffect(() => {
    if (values.investments) {
      const total = values.investments.reduce(
        (sum, inv) => sum + (Number(inv.inv_amt) || 0),
        0
      );
      onTotalAmountChange && onTotalAmountChange(total);
    }
  }, [values.investments, onTotalAmountChange]);

  return null;
};

const InvestmentsSection = ({
  FE,
  investments,
  setInvestments,
  activeTab,
  setActiveTab,
  onTotalAmountChange,
}) => {
  const { t } = useTranslation();

  const selectFormControlSX = {
    minWidth: 200,
    maxWidth: "100%",
  };

  const [showOtherScheme, setShowOtherScheme] = React.useState([]);

  React.useEffect(() => {
    const initialShowOtherScheme = investments.map(inv => inv.inv_scheme === "Other");
    setShowOtherScheme(initialShowOtherScheme);
  }, [investments]);

  const initialValues = {
    investments: investments?.length > 0 
      ? investments.map(inv => ({
          ...inv,
          investmentMode: inv.investmentMode || "NEFT",
          inv_bank_name: FE,
        }))
      : [{
          investmentMode: "NEFT",
          inv_account_no: "",
          inv_ifsc_code: "",
          inv_bank_name: FE,
          inv_branch_name: "",
          inv_scheme: "",
          inv_amt: "",
          inv_proof: null,
        }]
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={investmentValidationSchema}
      enableReinitialize
      onSubmit={(values) => {
        setInvestments(values.investments);
        setActiveTab(activeTab + 1);
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        setFieldValue,
        setFieldTouched,
        isValid,
        validateForm,
        submitForm,
      }) => {
        // ✅ Handle Cash auto-fill on investment mode change - NO useEffect loop
        const handleInvestmentModeChange = (i, e) => {
          const newMode = e.target.value;
          handleChange(e); // Let Formik handle the change
          
          // Auto-fill Cash values immediately
          if (newMode === "Cash") {
            const investmentIndex = i + 1;
            setFieldValue(`investments[${i}].inv_account_no`, `Cash${investmentIndex}`);
            setFieldValue(`investments[${i}].inv_ifsc_code`, "NA");
            setFieldValue(`investments[${i}].inv_branch_name`, "NA");
          }
        };

        const handleSchemeChange = (i, e) => {
          const val = e.target.value;
          if (val === "Other") {
            setShowOtherScheme((prev) => {
              const newState = [...prev];
              newState[i] = true;
              return newState;
            });
            setFieldValue(`investments[${i}].inv_scheme`, "");
            setFieldTouched(`investments[${i}].inv_scheme`, false);
          } else {
            setFieldValue(`investments[${i}].inv_scheme`, val);
            setShowOtherScheme((prev) => {
              const newState = [...prev];
              newState[i] = false;
              return newState;
            });
          }
        };

        const handleSubmit = async (e) => {
          e.preventDefault();
          await validateForm();
          const isFormValid = Object.keys(errors).length === 0;
          
          if (isFormValid) {
            submitForm();
          } else {
            const touchedFields = {};
            values.investments.forEach((_, index) => {
              touchedFields[`investments[${index}].investmentMode`] = true;
              touchedFields[`investments[${index}].inv_account_no`] = true;
              touchedFields[`investments[${index}].inv_ifsc_code`] = true;
              touchedFields[`investments[${index}].inv_bank_name`] = true;
              touchedFields[`investments[${index}].inv_branch_name`] = true;
              touchedFields[`investments[${index}].inv_scheme`] = true;
              touchedFields[`investments[${index}].inv_amt`] = true;
              touchedFields[`investments[${index}].inv_proof`] = true;
            });
            Object.keys(touchedFields).forEach(field => {
              setFieldTouched(field, true, false);
            });
          }
        };

        const totalInvestment = values.investments.reduce(
          (sum, inv) => sum + (Number(inv.inv_amt) || 0),
          0
        );

        return (
          <Container maxWidth={false} sx={{ mt: 5, maxWidth: 800 }}>
            <Paper elevation={4} sx={{ p: 4, borderRadius: 3 }}>
              <Typography variant="h4" fontWeight="700" color="primary.main" gutterBottom>
                {t('investments.heading')}
              </Typography>
              <Form noValidate>
                <Stack spacing={3}>
                  <TotalWatcher onTotalAmountChange={onTotalAmountChange} />
                  
                  <FieldArray name="investments">
                    {({ remove, push }) => (
                      <>
                        {values.investments.map((inv, i) => {
                          const isCashMode = inv.investmentMode === "Cash";
                          
                          return (
                            <Box
                              key={i}
                              mb={2}
                              p={2}
                              sx={{ border: "1px solid #ccc", borderRadius: 2 }}
                            >
                              <FormControl 
                                fullWidth 
                                error={touched.investments?.[i]?.investmentMode && Boolean(errors.investments?.[i]?.investmentMode)}
                                sx={{ mb: 2 }}
                              >
                                <InputLabel id={`investment_mode_label_${i}`}>
                                  {'Investment Mode'}
                                </InputLabel>
                                <Select
                                  labelId={`investment_mode_label_${i}`}
                                  name={`investments[${i}].investmentMode`}
                                  value={inv.investmentMode || "NEFT"}
                                  label={'Investment Mode'}
                                  onChange={(e) => handleInvestmentModeChange(i, e)} // ✅ Custom handler
                                  onBlur={handleBlur}
                                >
                                  <MenuItem value="Cash">Cash</MenuItem>
                                  <MenuItem value="NEFT">NEFT</MenuItem>
                                  <MenuItem value="Cheque">Cheque</MenuItem>
                                  <MenuItem value="RTGS">RTGS</MenuItem>
                                  <MenuItem value="IMPS">IMPS</MenuItem>
                                  <MenuItem value="Other">Other</MenuItem>
                                </Select>
                                {touched.investments?.[i]?.investmentMode && errors.investments?.[i]?.investmentMode && (
                                  <Typography color="error" variant="caption">
                                    {errors.investments[i].investmentMode}
                                  </Typography>
                                )}
                              </FormControl>

                              {/* ALWAYS SHOW Bank Details */}
                              <TwoFieldRow>
                                <TextField
                                  label={`${t('investments.invAccountNo')} *`}
                                  name={`investments[${i}].inv_account_no`}
                                  value={inv.inv_account_no}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  error={
                                    touched.investments?.[i]?.inv_account_no &&
                                    Boolean(errors.investments?.[i]?.inv_account_no)
                                  }
                                  helperText={
                                    touched.investments?.[i]?.inv_account_no &&
                                    errors.investments?.[i]?.inv_account_no
                                  }
                                  fullWidth
                                  inputProps={{ 
                                    readOnly: isCashMode
                                  }}
                                />
                                <TextField
                                  label={`${t('investments.ifscCode')} *`}
                                  name={`investments[${i}].inv_ifsc_code`}
                                  value={inv.inv_ifsc_code}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  error={
                                    touched.investments?.[i]?.inv_ifsc_code &&
                                    Boolean(errors.investments?.[i]?.inv_ifsc_code)
                                  }
                                  helperText={
                                    touched.investments?.[i]?.inv_ifsc_code &&
                                    errors.investments?.[i]?.inv_ifsc_code
                                  }
                                  fullWidth
                                  inputProps={{ 
                                    readOnly: isCashMode
                                  }}
                                />
                              </TwoFieldRow>

                              <TwoFieldRow>
                                <TextField
                                  label={`${t('investments.bankName')} *`}
                                  name={`investments[${i}].inv_bank_name`}
                                  value={inv.inv_bank_name || FE}
                                  inputProps={{ readOnly: true }}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  error={
                                    touched.investments?.[i]?.inv_bank_name &&
                                    Boolean(errors.investments?.[i]?.inv_bank_name)
                                  }
                                  helperText={
                                    touched.investments?.[i]?.inv_bank_name &&
                                    errors.investments?.[i]?.inv_bank_name
                                  }
                                  fullWidth
                                />
                                <TextField
                                  label={`${t('investments.branchName')} *`}
                                  name={`investments[${i}].inv_branch_name`}
                                  value={inv.inv_branch_name}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  error={
                                    touched.investments?.[i]?.inv_branch_name &&
                                    Boolean(errors.investments?.[i]?.inv_branch_name)
                                  }
                                  helperText={
                                    touched.investments?.[i]?.inv_branch_name &&
                                    errors.investments?.[i]?.inv_branch_name
                                  }
                                  fullWidth
                                  inputProps={{ 
                                    readOnly: isCashMode
                                  }}
                                />
                              </TwoFieldRow>

                              <TwoFieldRow>
                                <Box sx={{ minWidth: 200, flex: 1 }}>
                                  {!showOtherScheme[i] ? (
                                    <FormControl
                                      fullWidth
                                      margin="normal"
                                      error={
                                        touched.investments?.[i]?.inv_scheme &&
                                        Boolean(errors.investments?.[i]?.inv_scheme)
                                      }
                                      sx={selectFormControlSX}
                                    >
                                      <InputLabel id={`inv_scheme_label_${i}`}>
                                        {t('investments.scheme')}
                                      </InputLabel>
                                      <Select
                                        labelId={`inv_scheme_label_${i}`}
                                        name={`investments[${i}].inv_scheme`}
                                        value={inv.inv_scheme || ""}
                                        label={t('investments.scheme')}
                                        onChange={(e) => handleSchemeChange(i, e)}
                                        onBlur={handleBlur}
                                      >
                                        <MenuItem value="">
                                          <em>{t('common.select')}</em>
                                        </MenuItem>
                                        <MenuItem value="SB">{t('investments.sb')}</MenuItem>
                                        <MenuItem value="FD">{t('investments.fd')}</MenuItem>
                                        <MenuItem value="RD">{t('investments.rd')}</MenuItem>
                                        <MenuItem value="PPF">{t('investments.ppf')}</MenuItem>
                                        <MenuItem value="Other">{t('investments.other')}</MenuItem>
                                      </Select>
                                      {touched.investments?.[i]?.inv_scheme &&
                                        errors.investments?.[i]?.inv_scheme && (
                                          <Typography color="error" variant="caption" sx={{ ml: 2 }}>
                                            {errors.investments[i].inv_scheme}
                                          </Typography>
                                        )}
                                    </FormControl>
                                  ) : (
                                    <TextField
                                      label={`${t('investments.specifyScheme')} *`}
                                      name={`investments[${i}].inv_scheme`}
                                      value={inv.inv_scheme || ""}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      fullWidth
                                      error={
                                        touched.investments?.[i]?.inv_scheme &&
                                        Boolean(errors.investments?.[i]?.inv_scheme)
                                      }
                                      helperText={
                                        touched.investments?.[i]?.inv_scheme &&
                                        errors.investments?.[i]?.inv_scheme
                                      }
                                      InputProps={{
                                        endAdornment: (
                                          <Button
                                            onClick={() => {
                                              setShowOtherScheme((prev) => {
                                                const newState = [...prev];
                                                newState[i] = false;
                                                return newState;
                                              });
                                              setFieldValue(`investments[${i}].inv_scheme`, "");
                                            }}
                                            size="small"
                                            sx={{ ml: 1 }}
                                          >
                                            {t('common.change')}
                                          </Button>
                                        ),
                                      }}
                                    />
                                  )}
                                </Box>
                                <TextField
                                  label={`${t('investments.amount')} *`}
                                  name={`investments[${i}].inv_amt`}
                                  value={inv.inv_amt}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  error={
                                    touched.investments?.[i]?.inv_amt &&
                                    Boolean(errors.investments?.[i]?.inv_amt)
                                  }
                                  helperText={
                                    touched.investments?.[i]?.inv_amt &&
                                    errors.investments?.[i]?.inv_amt
                                  }
                                  fullWidth
                                />
                              </TwoFieldRow>

                              <TwoFieldRow>
                                <Box sx={{ flex: 1 }}>
                                  <UploadWithLabel
                                    label={t('investments.uploadProof')}
                                    name={`investments[${i}].inv_proof`}
                                    onChange={(e) => {
                                      setFieldValue(`investments[${i}].inv_proof`, e.currentTarget.files[0]);
                                      setFieldTouched(`investments[${i}].inv_proof`, true);
                                    }}
                                    file={inv.inv_proof}
                                    error={
                                      touched.investments?.[i]?.inv_proof &&
                                      Boolean(errors.investments?.[i]?.inv_proof)
                                    }
                                    helperText={
                                      touched.investments?.[i]?.inv_proof &&
                                      errors.investments?.[i]?.inv_proof
                                    }
                                  />
                                  {touched.investments?.[i]?.inv_proof && errors.investments?.[i]?.inv_proof && (
                                    <Typography color="error" variant="caption" sx={{ ml: 2 }}>
                                      {errors.investments[i].inv_proof}
                                    </Typography>
                                  )}
                                </Box>
                              </TwoFieldRow>

                              <Button
                                variant="outlined"
                                color="error"
                                onClick={() => remove(i)}
                                sx={{ mt: 1 }}
                              >
                                {t('common.remove')}
                              </Button>
                            </Box>
                          );
                        })}

                        <Button
                          variant="contained"
                          sx={{ mt: 2 }}
                          onClick={() => {
                            push({
                              investmentMode: "NEFT",
                              inv_account_no: "",
                              inv_ifsc_code: "",
                              inv_bank_name: FE,
                              inv_branch_name: "",
                              inv_scheme: "",
                              inv_amt: "",
                              inv_proof: null,
                            });
                            setShowOtherScheme(prev => [...prev, false]);
                          }}
                        >
                          {t('investments.addInvestment')}
                        </Button>

                        <Box
                          sx={{
                            mt: 4,
                            p: 2,
                            border: "1px solid #999",
                            borderRadius: 2,
                            backgroundColor: "#f9f9f9",
                          }}
                        >
                          <Typography variant="h6" gutterBottom>
                            {t('investments.summary')}
                          </Typography>
                          <TextField
                            label={t('investments.totalInvestmentAmount')}
                            value={totalInvestment.toFixed(2)}
                            InputProps={{ readOnly: true }}
                            fullWidth
                          />
                        </Box>
                      </>
                    )}
                  </FieldArray>

                  <Box mt={1} sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Button
                      variant="outlined"
                      onClick={() => activeTab > 0 && setActiveTab(activeTab - 1)}
                    >
                      {t('common.back')}
                    </Button>
                    <Button 
                      type="button" 
                      variant="contained"
                      onClick={handleSubmit}
                    >
                      {t('common.next')}
                    </Button>
                  </Box>
                </Stack>
              </Form>
            </Paper>
          </Container>
        );
      }}
    </Formik>
  );
};

export default InvestmentsSection;
